const requests = {
    diagrams: `/v1/co/diagrams`,
    templates: `/v1/co/diagrams-templates`,

    feedback: 'v1/co/requests/feedback',
    invitePeople: `/v1/co/requests/invite`,

    checkoutRequest: `/v1/co/checkout-request`,

    // Invitations
    invitationVerify: `/v1/co/invitations/verify`,
    invitationAccept: `/v1/co/invitations/accept`,

    // Workspaces & teams
    // GET  /v1/co/workspaces                          → list user's workspaces
    // GET  /v1/co/workspaces/:id/teams                → teams in a workspace
    // GET  /v1/co/workspaces/:id/members              → members in a workspace
    workspaces: `/v1/co/workspaces`,
};

export default requests;
